import React from "react";
import manish from "../assets/images/About/1234.jpeg";

function About() {
  return (
    <div className="about-grid" id="about">
      <div>
        <img className="about-image" src={manish} alt="not found"></img>
        <p>karnibatteries@gmail.com</p>
        <p>+91 9521271856</p>
      </div>
      <div>
        <img className="about-image" src={manish} alt="not found"></img>
        <p>karnibatteries@gmail.com</p>
        <p>+91 9521271856</p>
      </div>
      <div>
        <img className="about-image" src={manish} alt="not found"></img>
        <p>karnibatteries@gmail.com</p>
        <p>+91 9521271856</p>
      </div>
    </div>
  );
}

export default About;
